export default () => {
    var events = {
      "01/05": "Female cuckoos are arriving.",
      "02/05": "The first nightjars arrive, churring and wing clapping at dusk.",
      "03/05": "Wild bluebells are in full flower in the woods.",
      "04/05": "Young tawny owls may be calling now, before they have broken out of their egg.",
      "05/05": "The first young grebes have hatched and are carried on the backs of their parents.",
      "06/05": "Spotted flycatchers are arriving from Africa.",
      "07/05": "The rare golden oriole’s fluting song might be heard.",
      "08/05": "Oaks are in flower, producing a lot of pollen.",
      "09/05": "Holly blue butterflies are on the wing.",
      "10/05": "The last of the summer migrants have arrived: swifts are screaming across the sky.",
      "11/05": "Oxeye daisy in flower.",
      "12/05": "Butterflies abound: speckled wood, wall brown, green-veined white, dingy skipper on the wing.",
      "13/05": "Meadow froghoppers are appearing from their foam ‘cuckoo spit’ nests on plant stems.",
      "14/05": "Young moles are being born.",
      "15/05": "Young eels start ascending rivers from the sea.",
      "16/05": "Bogbean and yellow iris in flower along the banks of ponds.",
      "17/05": "The air is full of blackbird song.",
      "18/05": "Ash are coming into leaf, one of the last trees of the spring.",
      "19/05": "Swallowtail butterflies are on the wing.",
      "20/05": "The first red deer calves of the year are being born.",
      "21/05": "Young great tits are leaving their nests.",
      "22/05": "Most swifts have laid an egg under loose roof tiles.",
      "23/05": "Mistle thrushes cease singing, their work done.",
      "24/05": "Fox cubs are emerging from their earths and playing above the ground.",
      "25/05": "Common spotted orchid, common mallow, yellow tattle are in flower.",
      "26/05": "Brightly coloured garden tiger moths are on the wing.",
      "27/05": "Hummingbird hawk-moths are on the wing, looking for nectar.",
      "28/05": "The first caddisflies are emerging from water.",
      "29/05": "Robins have their second brood; the young of the first brood have left their nest.",
      "30/05": "Meadows are full of buttercups.",
      "31/05": "Poisonous hound’s tongue is in flower.",
      "01/06": "Most Eurasian hobbies have laid an egg.",
      "02/06": "The flowering period of the lesser butterfly orchid begins.",
      "03/06": "Female cuckoos are visiting nests, removing one of the eggs to lay one of their own.",
      "04/06": "Wild dog roses are blooming.",
      "05/06": "Hedgehogs are giving birth.",
      "06/06": "Extremely poisonous deadly nightshade or belladonna in flower.",
      "07/06": "Meadowsweet with large white plumes is flowering in damp meadows.",
      "08/06": "Rough chervil is in flower.",
      "09/06": "The green tortrix moth is looking for suitable leaves to roll into egg cases.",
      "10/06": "Snipe are displaying by flying downwards making a ‘drumming’ noise with their tail feathers.",
      "11/06": "Most of the female reed warblers have laid their eggs.",
      "12/06": "Poppies are flowering in fields, on unused sites and road sides.",
      "13/06": "Stag beetles are emerging.",
      "14/06": "Young swallows are big enough to start leaving their nests.",
      "15/06": "The first edible giant puffballs are appearing in meadows.",
      "16/06": "Large and small tortoiseshell butterflies can be seen.",
      "17/06": "Bats are fully active, each catching thousands of insects at night.",
      "18/06": "Scotch bonnet fungi suddenly appear in pastures and sometimes in fairy rings.",
      "19/06": "Young harvest mice are in their woven grass nests suspended between stalks.",
      "20/06": "Blackbirds stop brooding and cease their passionate singing.",
      "21/06": "The first young toads are moving onto dry land.",
      "22/06": "Small skipper butterflies are on the wing.",
      "23/06": "Common seals are giving birth to their young on sand flats in the sea.",
      "24/06": "Great horse-flies are emerging.",
      "25/06": "The cuckoo gradually stops calling its own name.",
      "26/06": "The dark green fritillary is on the wing with its black-orange chequered wings.",
      "27/06": "Chaffinches cease singing.",
      "28/06": "Harbour porpoises concentrate on breeding; their young are born eleven months later.",
      "29/06": "Grass snakes are laying their eggs in sweltering dung hills and compost heaps.",
      "30/06": "Elephant hawk-moths are visiting honeysuckle flowers for pollen.",
      "01/07": "Glowworms are emerging.",
      "02/07": "The first wasps start looking for something sweet for their young.",
      "03/07": "Rosebay willowherb is flowering.",
      "04/07": "Vervain is flowering.",
      "05/07": "Brown hawker dragonfly and willow emerald damselfly are on the wing.",
      "06/07": "Female bats are suckling their young.",
      "07/07": "Most of the adult cuckoos have departed to Africa.",
      "08/07": "Purple emperor butterflies on the wing near willows.",
      "09/07": "Young magpies are following their parents, begging them for food.",
      "10/07": "Roe deer start mating.",
      "11/07": "Silver-washed fritillary butterflies appear.",
      "12/07": "Carnivorous sundews are flowering in sphagnum bogs.",
      "13/07": "The red berries of the rowans are ripening.",
      "14/07": "Large numbers of common blue damselflies are on the wing.",
      "15/07": "In sunny places the first blackberries are ripe.",
      "16/07": "Female otters are giving birth.",
      "17/07": "Cotton grasses and bog asphodel are flowering.",
      "18/07": "Meadow brown butterfly, dark green fritillary and large blue are on the wing.",
      "19/07": "Song thrushes cease singing.",
      "20/07": "Rose bedeguar galls are appearing on wild rose species.",
      "21/07": "The first chanterelle fungi are appearing in beech woods.",
      "22/07": "Most birdsong has ended but skylarks and yellowhammers are still singing.",
      "23/07": "Wasps on the wing abound.",
      "24/07": "The large copper butterfly can be spotted flying.",
      "25/07": "Immigrant clouded yellow butterflies are appearing on clover fields.",
      "26/07": "Common seals begin their display and mating ritual.",
      "27/07": "Migrant hawker dragonflies are on the wing.",
      "28/07": "Small skipper butterflies are on the wing.",
      "29/07": "Water dropwort is flowering. Its roots are very poisonous.",
      "30/07": "Honeysuckle berries start ripening.",
      "31/07": "Gipsywort or bugleweed is in bloom in wetland areas.",
      "01/08": "Second broods of swallows are fledging.",
      "02/08": "The caterpillars of the eyed hawk-moth are now fully fed.",
      "03/08": "Small red-eyed damselflies on the wing.",
      "04/08": "The common earthball fungus attacked by Boletus parasiticus.",
      "05/08": "Ivy-leaved bellflower in flower.",
      "06/08": "Foxgloves are abundant.",
      "07/08": "Yellowhammers stop singing.",
      "08/08": "Young frogs have dispersed and forage for insects in the grass.",
      "09/08": "Devil’s-bit scabious still in flower.",
      "10/08": "Swifts begin to leave for Africa.",
      "11/08": "Silver spotted skipper butterflies on the wing.",
      "12/08": "Young slow worms hatch.",
      "13/08": "Second broods of martins fledge.",
      "14/08": "Robins commence their autumn song.",
      "15/08": "Moles cast out their young.",
      "16/08": "Blue hawker dragonflies on the wing.",
      "17/08": "Small emerald spreadwings on the wing.",
      "18/08": "Great woolly-headed thistle flowering.",
      "19/08": "Larvae of elephant and privet hawk-moths almost fully fed.",
      "20/08": "The false death cap fungus appears on sandy soil under oaks and beeches.",
      "21/08": "Young bats begin to catch insects for themselves and no longer need their mothers’ milk.",
      "22/08": "After incubating their eggs internally, smooth snakes are giving birth to live young.",
      "23/08": "Around this time winged ants appear in swarms from their nests.",
      "24/08": "Lapwings flock together for their autumnal migration.",
      "25/08": "Flying alone and for the first time, young cuckoos are departing for Africa.",
      "26/08": "Horn of plenty or ‘trumpet of death’ fungus is appearing in woods.",
      "27/08": "The Adonis blue butterfly is on the wing.",
      "28/08": "Caterpillars of the emperor moth are feeding on heather.",
      "29/08": "Adult shrews are at the end of their lives and die of exhaustion.",
      "30/08": "The first elderberries are ripe and are eaten by wood pigeons.",
      "31/08": "Peacock butterflies can be found on the wing or resting.",
      "01/09": "Death’s-head hawkmoths are on the wing.",
      "02/09": "Many glistening inky cap fungi can be found.",
      "03/09": "Blackberries start ripening.",
      "04/09": "Young natterjack toads are leaving the water.",
      "05/09": "Silk button spangle galls are appearing on the back of oak leaves.",
      "06/09": "Fancifully shaped knopper galls are falling from oaks.",
      "07/09": "The last silver-spotted skippers can be spotted on the wing.",
      "08/09": "Wasp nest beetles appear from underground wasps’ nests.",
      "09/09": "Parasol fungi appear in meadows and along road sides.",
      "10/09": "Crane flies or daddy longlegs are abundant.",
      "11/09": "The first horse chestnuts are ripe and fall from the trees.",
      "12/09": "Shaggy ink cap fungus appears on disturbed and nutrient-rich soils.",
      "13/09": "The stemless dwarf thistle can still be found blooming.",
      "14/09": "Lime trees begin to shed their leaves.",
      "15/09": "Red deer stags start their mating season rut.",
      "16/09": "Common kingfishers can be spotted frequently.",
      "17/09": "The first acorns are falling.",
      "18/09": "Bracken assumes its autumnal tinting.",
      "19/09": "Male badgers are preparing their burrows to accommodate multiple females.",
      "20/09": "The first swallows and martins start their migration south.",
      "21/09": "Beechnuts are now plentiful in the woods.",
      "22/09": "Ivy is beginning to bloom.",
      "23/09": "Mistle thrushes are feeding on ripe orange rowan berries.",
      "24/09": "Caddis flies are swarming over ponds in the evening.",
      "25/09": "Turtle doves are leaving to spend the winter in West Africa.",
      "26/09": "Second flowering of honeysuckle.",
      "27/09": "False truffles can be seen in pine woods, after rabbits have dug them up.",
      "28/09": "Dormice and squirrels are stocking up their winter supplies.",
      "29/09": "Scarlet waxcap fungi are appearing in fields and on lawns.",
      "30/09": "Migrating silver Y moths are on their way south.",
      "01/10": "Adult eels are migrating from inland waters to their spawning grounds in the Sargasso Sea.",
      "02/10": "Coconut scented milk cap fungus found under many birches in woods.",
      "03/10": "Hips, haws and sloes are now ripe.",
      "04/10": "Field mushrooms in striking fairy rings are in fields and on lawns.",
      "05/10": "Rutting red deer are using their antlers in the competition for hinds.",
      "06/10": "Fly agaric are emerging under birches and other trees.",
      "07/10": "Starlings are starting to roost in huge flocks.",
      "08/10": "Green-veined white caterpillars begin to hibernate.",
      "09/10": "Queen wasps are going into hibernation.",
      "10/10": "Blackbirds are feeding on fallen apples.",
      "11/10": "Ladybird beetles are going into hibernation, often in homes.",
      "12/10": "Trees are shedding their leaves but oak and ash are still green.",
      "13/10": "Cauliflower fungus is appearing at the base of Scots pine trunks.",
      "14/10": "Chaffinches and lesser redpolls are sometimes singing on fine mornings.",
      "15/10": "Wrens are beginning their autumn singing.",
      "16/10": "The last martins and swallows are leaving to spend the winter in Africa.",
      "17/10": "Dogwood leaves are turning a beautiful red.",
      "18/10": "At dusk blackbirds are making their short high pitch alarm calls.",
      "19/10": "Young wood pigeons are leaving the nest.",
      "20/10": "Amphibians start withdrawing into their hibernation shelters.",
      "21/10": "The vomiting russula or the sickener fungus is appearing on damp, acid soils.",
      "22/10": "The northern red oak takes on a striking red.",
      "23/10": "The first fieldfares and redwings are arriving from the high north, migrating by night.",
      "24/10": "Brent geese are returning from their northern breeding grounds with their young.",
      "25/10": "Slow worms are going into hibernation, hidden in humus and rough grasses.",
      "26/10": "The first woodcocks are arriving from Finland and Russia to spend the winter here.",
      "27/10": "Comma butterflies have stopped flying for this year.",
      "28/10": "The birch leaves have taken on their autumnal colours.",
      "29/10": "Peacock butterflies stop flying as autumn progresses.",
      "30/10": "Dormice are going into hibernation until April.",
      "31/10": "Virtually all butterflies have stopped flying because of the cold.",
      "01/11": "Mistle thrushes begin singing again from treetops.",
      "02/11": "The brown long-eared bat starts to hibernate in trees, hollow walls, caves and mines.",
      "03/11": "The grass stops growing.",
      "04/11": "In fields, vast numbers of money spiders cover the grass with threads of silk.",
      "05/11": "Autumnal leaf tinting is usually at its best about this time.",
      "06/11": "Mermaid’s purses holding shark’s or skate’s eggs wash up on beaches.",
      "07/11": "Serotine bats are spending the winter in cavity walls, under roof tiles and in disused chimneys.",
      "08/11": "Salmon start to ascend rivers from the sea to spawn upstream.",
      "09/11": "The last red admiral butterflies are still on the wing.",
      "10/11": "Thousands of wild geese are back from their summer breeding grounds in the Arctic.",
      "11/11": "Young shrews are left to survive the winter on their own.",
      "12/11": "Frogs hibernate in the unfrozen muddy layer on the bottom of ponds and pools.",
      "13/11": "Candlesnuff fungus is abundant on old stumps.",
      "14/11": "The colourful butter waxcap appears in meadows.",
      "15/11": "The spitting spider goes hunting by night.",
      "16/11": "Adders and grass snakes go into hibernation.",
      "17/11": "Hedgehogs go into hibernation until April.",
      "18/11": "Lapwings are feeding in flocks on fields.",
      "19/11": "Brown witches’ butter fungus is growing on dead birch and oak branches.",
      "20/11": "Occasional appearance of brimstone butterflies.",
      "21/11": "Squirrels retire to their winter retreats.",
      "22/11": "Most moths start to hibernate as a pupa among fallen leaves or other hidden spots.",
      "23/11": "Long-eared owls form communal roosts.",
      "24/11": "Greenfinches assemble in flocks for their collective wintering.",
      "25/11": "Common bracket fungus is abundant on dead wood.",
      "26/11": "The pedunculate or English oaks are now completely bare.",
      "27/11": "The nettle cells of stinging nettles are losing strength.",
      "28/11": "The fluted bird’s nest fungus ejects its spores.",
      "29/11": "Young magpies without a territory are roosting in small flocks.",
      "30/11": "Pipistrelle bats are going into hibernation.",
      "01/12": "Fluted bird’s nest fungi are catching rain drops, ejecting their spores.",
      "02/12": "The common shrew is now underground and hunting for invertebrates.",
      "03/12": "Male foxes are calling in the night to find a female to mate with.",
      "04/12": "Geophilomorph centipedes are glowing in the dark.",
      "05/12": "Red-stemmed feather moss abundant on sandy soil.",
      "06/12": "The rough-mantled doris sea slug is looking for barnacles to feed on.",
      "07/12": "Yellowhammers are congregating in winter flocks at nutrient-rich places.",
      "08/12": "At night luminous centipedes can be spotted.",
      "09/12": "The first young of grey seals are being born.",
      "10/12": "Blackbirds clear circles of dead leaves to get at insects and worms in the ground.",
      "11/12": "The song thrush sings at dawn in mild weather.",
      "12/12": "Titmice extract larvae from oak marble galls and eat them.",
      "13/12": "Groundsel can be seen in flower, in sheltered places all year long.",
      "14/12": "Stoats in high, northern regions have their white coat for winter.",
      "15/12": "The mating season of squirrels has begun.",
      "16/12": "The high, sharp call of the great spotted woodpecker can be heard high up in the trees.",
      "17/12": "Shepherd’s purse is occasionally still flowering.",
      "18/12": "Many insects are overwintering in the hollow stems of dead plants.",
      "19/12": "The first scarlet elf cup fungi appear.",
      "20/12": "Long-tailed tit flocks are looking for food all day to survive.",
      "21/12": "Common chickweed is occasionally still flowering.",
      "22/12": "Compass jellyfish come near to the shore.",
      "23/12": "Slow worms can be spotted in sunny weather.",
      "24/12": "Early nuthatches commence their spring whistle.",
      "25/12": "Stag beetles can be spotted on a clear evening.",
      "26/12": "Yellow witches’ butter fungus can be seen on the stems of dead oak and other trees.",
      "27/12": "Yellow gorse is flowering profusely.",
      "28/12": "Moles throw up hillocks when the ground is not frozen hard.",
      "29/12": "Robins are singing.",
      "30/12": "Wild boars churn up the fallen leaves looking for acorns.",
      "31/12": "Earthworms are pulling dead leaves into their holes to eat them.",
      "01/01": "Badgers are asleep deep underground.",
      "02/01": "Dunnocks commence their birdsong.",
      "03/01": "The black-spotted chestnut moth can be spotted flying in the night.",
      "04/01": "Marsh tits begin to sing.",
      "05/01": "Beavers are satisfying their appetite with willow bark.",
      "06/01": "Rabbits gnaw the bark of holly and other shrubs if the weather is severe.",
      "07/01": "Stock doves can be heard calling.",
      "08/01": "Smooth newts begin breeding if the weather is warm enough.",
      "09/01": "Rabbits start devoting themselves to breeding.",
      "10/01": "Lesser spotted woodpeckers start to drum.",
      "11/01": "Red dead-nettle already flowering here and there.",
      "12/01": "The pale brindled beauty moth flies from now till late April.",
      "13/01": "The elegant swan’s-neck thread moss is forming its reproductive organs.",
      "14/01": "Common winter damselflies are on the wing on warm days.",
      "15/01": "The first yellow daffodils are flowering.",
      "16/01": "The first buntings start singing.",
      "17/01": "Dog sick slime mould appears around bramble stems.",
      "18/01": "The loudest singers now are the great tits.",
      "19/01": "Brown hairstreak butterflies are laying eggs in blackthorn bushes.",
      "20/01": "Beavers are starting their mating season.",
      "21/01": "Wood larks are singing.",
      "22/01": "Black witches’ butter fungus is growing on dead branches.",
      "23/01": "The dumbledore beetle appears.",
      "24/01": "Snowdrop leaves are emerging.",
      "25/01": "Early skylarks start singing.",
      "26/01": "Nathusius’ pipistrelle bats may be spotted flying if it is not too cold.",
      "27/01": "Hare mating season begins and continues well into summer.",
      "28/01": "The first robins start building their nests.",
      "29/01": "Winter gnats abound.",
      "30/01": "The first snowdrops begin to flower.",
      "31/01": "Earthworms lie out.",
      "01/02": "Small tortoiseshell butterflies start to emerge from hibernation.",
      "02/02": "Greenfinches separate from flocks to continue on their own.",
      "03/02": "Moles prepare their underground nests for their young.",
      "04/02": "Treecreepers commence their spring call.",
      "05/02": "Tawny owls hoot at dusk.",
      "06/02": "Hawfinches feed on holly berries.",
      "07/02": "Blackbirds sing at dusk.",
      "08/02": "Winter jasmine is flowering profusely.",
      "09/02": "Collared doves are cooing loudly in the morning.",
      "10/02": "The first crop of glistening ink cap fungus appears on dead broad-leaved trees.",
      "11/02": "Greater spotted woodpeckers drum to mark their territory.",
      "12/02": "Male moles in search for a partner dig long tunnels throwing up many hillocks.",
      "13/02": "Badgers are giving birth to young.",
      "14/02": "Woodcocks are making their flight displays‚‘roding’ to mark their breeding territory.",
      "15/02": "Yellowhammers start to sing their characteristically shrill notes.",
      "16/02": "Barn owls are mating.",
      "17/02": "Peacock and brimstone butterflies emerge from hibernation.",
      "18/02": "The first primroses appear.",
      "19/02": "The great crested grebe’s mirror courtship dance begins.",
      "20/02": "Salmon start to descend rivers on their migration to the sea.",
      "21/02": "Frogs are busy mating and producing frogspawn.",
      "22/02": "Chaffinches commence singing.",
      "23/02": "Lesser periwinkle are blooming with brightly blue flowers.",
      "24/02": "Goldcrests begin their almost inaudibly high calls.",
      "25/02": "Adders emerge from hibernation.",
      "26/02": "Brent geese start to leave for the Arctic islands.",
      "27/02": "Early-nesting herons already have eggs.",
      "28/02": "Slow worms revive from torpidity.",
      "01/03": "Most tawny owls have laid their eggs.",
      "02/03": "Wood anemones in flower.",
      "03/03": "The first queen wasps emerge from hibernation.",
      "04/03": "Willows and marsh-marigolds in flower.",
      "05/03": "Curlews begin their display flights, rising steeply then gliding down while singing.",
      "06/03": "Mistle thrushes are nesting.",
      "07/03": "Blackthorn in flower before it has leaves.",
      "08/03": "Early swans start building their nests.",
      "09/03": "The first lesser celandine flowers appear.",
      "10/03": "Hares are standing on hind legs and boxing, usually it’s the female fending off males.",
      "11/03": "The first generation of brimstone butterflies start their flight period.",
      "12/03": "Male yews begin shedding abundant amounts of pollen.",
      "13/03": "The large white butterflies are on the wing.",
      "14/03": "Sparrowhawks can be seen soaring over their territories only at this time of year.",
      "15/03": "Common frogs start to emerge.",
      "16/03": "Black ants remove the seal from the entrance to the nest and begin to forage above ground.",
      "17/03": "The first speckled wood butterflies can be spotted flying.",
      "18/03": "Common frogs start croaking to attract the attention of females.",
      "19/03": "Wrens are singing higher in the trees, their voices carrying further.",
      "20/03": "Pine martens are giving birth.",
      "21/03": "The first newts return to the water.",
      "22/03": "Rosemary has started flowering.",
      "23/03": "The first horse chestnut leaves are unfolding.",
      "24/03": "Toads are mating and laying eggs.",
      "25/03": "Kingfishers are looking for nesting holes.",
      "26/03": "The first hazel leaves are appearing.",
      "27/03": "The first eggs of the natterjack toad have been left in shallow pools.",
      "28/03": "Magnolia are flowering before the first leaves appear.",
      "29/03": "Wheatears have arrived, one of the first long-distance migrant birds to return.",
      "30/03": "Long-eared owls are nesting.",
      "31/03": "Crows, jackdaws, magpies and rooks are building or repairing their nests.",
      "01/04": "The mating season has started for adders; the males compete in a dance to impress females.",
      "02/04": "The first chiffchaffs have returned and begin to sing their name.",
      "03/04": "The first young of the wild boar are born.",
      "04/04": "The first willow warbler song can be heard.",
      "05/04": "Tadpoles abound in ponds and pools.",
      "06/04": "Sparrowhawks and kestrels are nesting.",
      "07/04": "The first nightingales return.",
      "08/04": "Most buzzards have laid their first egg.",
      "09/04": "The distinctive orange-tip butterflies are flying.",
      "10/04": "Grass snakes are mating.",
      "11/04": "Male cuckoos begin to arrive from Sub-Saharan Africa and start calling their name.",
      "12/04": "Beavers are having their first young.",
      "13/04": "Ash trees are flowering.",
      "14/04": "Yellow wagtails have arrived from their winter retreats.",
      "15/04": "Hedgehogs are emerging from hibernation.",
      "16/04": "The small tortoiseshell butterfly and comma butterfly are at the peak of their flight period.",
      "17/04": "Young mallards are hatching and can be seen swimming.",
      "18/04": "Crab apples are flowering.",
      "19/04": "Grey squirrels prepare their dreys (tree nests).",
      "20/04": "Yellow archangel in flower.",
      "21/04": "Pied flycatchers and grasshopper warblers have returned from migration.",
      "22/04": "Pedunculate or English oak leaves unfolding.",
      "23/04": "Hawthorn hedgerows begin to blossom.",
      "24/04": "The wood warbler has arrived to spend the summer.",
      "25/04": "Great and blue tits are now sitting on eggs.",
      "26/04": "Rare migrating turtle doves that have survived being hunted while crossing Malta arrive in UK.",
      "27/04": "The first flowers of the horse chestnut tree are appearing.",
      "28/04": "The reed warbler is in the country.",
      "29/04": "The first swifts have arrived and will stay for one hundred days.",
      "30/04": "The male wren is busy making several nests, the female chooses one of them.",
    }
    
    let splasher = document.getElementById('splash');

    var today = (new Date()).toISOString().split('T')[0].split('-')
    var tk = today[2] + '/' + today[1]
    var ek = Object.keys(events).find(function (k) { return k == tk});
    
    if (ek) {
      splasher.innerHTML = events[ek];
    } else false;
    console.log('Date: ' + events[ek]);

    function closeSplash() {
      splasher.classList.add('opacity-0');
      setTimeout(function() {splasher.classList.add('hidden')}, 500);
    }

    setTimeout(function() {closeSplash()}, 4000);

    splasher.addEventListener('click', function() {closeSplash()});
  }
